import { Information } from 'assets/icons';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import useModal from 'components/modal/useModal';
import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';

const Remplacement = () => {
  const { dataCreateMission, setDataCreateMission } = UseContext();
  const { toggle } = useModal();

  // Préfill infos si motif.type === '3'
  const [infos, setInfos] = useState(() => {
    if (dataCreateMission?.motif?.type === '3') {
      return { ...dataCreateMission.motif };
    }
    return {
      type: '3',
      name: '',
      prenom: '',
      poste: '',
      message: '',
    };
  });
  const [lengthMessage, setLengthMessage] = useState(false);
  const [validMessage, setValidMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorName, setErrorName] = useState(false);
  const [errorPrenom, setErrorPrenom] = useState(false);
  const [errorPoste, setErrorPoste] = useState(false);

  const verif = infos.message.length;

  useEffect(() => {
    if (verif <= 8) {
      setErrorMessage(true);
      setLengthMessage(false);
    } else {
      setErrorMessage(false);
      setLengthMessage(true);
    }
  }, [infos.message, verif]);

  const handleChange = (e) => {
    const { name, type, value } = e.target;
    setInfos((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? e.target.checked : value,
    }));
  };

  const handleSubmit = () => {
    // Validation
    const errs = {
      name: infos.name === '',
      prenom: infos.prenom === '',
      poste: infos.poste === '',
      message: infos.message.length <= 8,
    };
    setErrorName(errs.name);
    setErrorPrenom(errs.prenom);
    setErrorPoste(errs.poste);
    setErrorMessage(errs.message);

    if (!errs.name && !errs.prenom && !errs.poste && !errs.message) {
      setDataCreateMission((prevData) => ({
        ...prevData,
        motif: infos,
      }));
      toggle();
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Remplacement d’un salarié absent
      </Modalheader>
      <ModalBody>
        <div className="grid grid-cols-2 gap-8">
          <div>
            <label
              htmlFor="name"
              className="block ft-sm font-medium text-gray-500"
            >
              Nom
            </label>
            <input
              name="name"
              value={infos.name}
              onChange={handleChange}
              className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg"
              type="text"
              required
            />
            {errorName && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                Veuillez indiquer un nom
              </p>
            )}
          </div>
          <div>
            <label
              htmlFor="prenom"
              className="block ft-sm font-medium text-gray-500"
            >
              Prénom
            </label>
            <input
              name="prenom"
              value={infos.prenom}
              onChange={handleChange}
              className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg"
              type="text"
              required
            />
            {errorPrenom && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                Veuillez indiquer un prénom
              </p>
            )}
          </div>
          <div className="col-span-2">
            <label
              htmlFor="poste"
              className="block ft-sm font-medium text-gray-500"
            >
              Poste remplacé
            </label>
            <input
              name="poste"
              value={infos.poste}
              onChange={handleChange}
              className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg"
              type="text"
              required
            />
            {errorPoste && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                Veuillez indiquer un poste
              </p>
            )}
          </div>
        </div>
        <div className="mt-5 flex flex-col">
          <label htmlFor="message">
            Décrivez précisément le motif de l’absence de votre salarié.
          </label>
          <textarea
            name="message"
            id="message"
            value={infos.message}
            onChange={handleChange}
            cols="30"
            rows="5"
            className="border border-gray-300 rounded-md"
            required
            maxLength={250}
            minLength={3}
            wrap="true"
          />
        </div>
        <span className="text-gray-400 nbLength">250 caractères </span>
        {errorMessage && (
          <p className="text-yellow-400 flex items-center gap-4">
            <Information wh={16} color={'#FFA43D'} />
            Veuillez faire un message de plus de 10 caractères
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          Annuler
        </Button>
        <Button
          size={'LG'}
          onClick={handleSubmit}
          disabled={!lengthMessage || errorName || errorPrenom || errorPoste}
        >
          Confirmer
        </Button>
      </ModalFooter>
    </>
  );
};

export default Remplacement;
